export default __webpack_public_path__ + "static/media/purplepic.b155dafb.png";